import { useState, useEffect } from 'react';

export type DeviceType = 'mobile' | 'desktop';

const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>(() => {
    // Initial check
    return window.innerWidth >= 768 ? 'desktop' : 'mobile';
  });

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(window.innerWidth >= 768 ? 'desktop' : 'mobile');
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceType;
};

export default useDeviceType;